import { useTranslation } from "react-i18next";
import { useWatch } from "react-hook-form";
import { IFormValues } from "../../../../../insert/types";
import { useQuery } from "@tanstack/react-query";
import { ReactQueryKey } from "../../../../../../types";
import { IGetCompanyReturn } from "../../../../../../api/services";
import { FormAutocomplete } from "../../../../../../components/fields";
import { editPendingBookingRce } from "../../../../recoil";
import { useRecoilValue } from "recoil";
const FormCig = () => {
    const { t } = useTranslation('booking');
    
    const isPendingBookingRce = useRecoilValue<boolean | undefined>(editPendingBookingRce);

    const rentalType = useWatch<IFormValues, 'basicDetails.rentalType'>({
        name: 'basicDetails.rentalType'
    });

    const companyQuery = useQuery<IGetCompanyReturn | null>({
        queryKey: [ReactQueryKey.Product, {segment: rentalType}],
        enabled: false,
    });

    return (
        <FormAutocomplete<IFormValues>
            name="basicDetails.cig"
            label={t('label.cig')}
            options={companyQuery?.data?.cig ?? []}
            loading={companyQuery.isLoading}
            disabled={isPendingBookingRce}
            isOptionEqualToValue={(option, value) => option === value}
        />
)
};

export default FormCig;
